import { render, staticRenderFns } from "./notification-bar.vue?vue&type=template&id=3056eda1&scoped=true&"
import script from "./notification-bar.vue?vue&type=script&lang=js&"
export * from "./notification-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056eda1",
  null
  
)

export default component.exports